/**
 * Every row is its own grid, so a `max-content` menu column would differ between the empty header
 * cell and the rows; the menu cells measure their content instead and the widest wins. This is the
 * floor: a 24px icon button with the cell's 20px padding on both sides, and no narrower than the
 * 58px row is tall.
 */
export const MENU_COLUMN_WIDTH = 64;
